<template>
    <div class="modal__container">
        <div class="modal__send_manual_pos">
            <div class="modal__send_manual_pos_header">
                <div class="modal__send_manual_pos_header_close cursor_pointer" @click.prevent="closeModal">
                    <svg height="24" width="24">
                        <use xlink:href="/icons/base.svg#close"></use>
                    </svg>
                </div>
                <div class="modal__send_manual_pos_header_text">
                    {{ __t('O.SEND_POS_MANUALLY_QUESTION') }}
                </div>
            </div>
            <div class="modal__send_manual_pos_buttons">
                <button class="modal__send_manual_pos_buttons_button color" @click.prevent="clickYes">
                    <div class="modal__send_manual_pos_buttons_button_text">
                        {{ __t('O.YES') }}
                    </div>
                </button>
                <button class="modal__send_manual_pos_buttons_button" @click.prevent="clickCancel">
                    <div class="modal__send_manual_pos_buttons_button_text">
                        {{ __t('O.CANCEL') }}
                    </div>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import {createHelpers} from "vuex-map-fields";
import {useToast} from 'vue-toastification';
import {__t} from "../../../helpers/translate";
const {mapFields: mOrders} = createHelpers({
    getterType: 'orders/getOrdersField',
    mutationType: 'orders/updateOrdersField',
})

const toast = useToast();
export default {
    name: "modal_send_manual_pos",
    props: {
    },
    emits: ['close_modal_send_manual_pos'],
    data() {
        return {
        }
    },
    beforeMount() {
        EventBus.$on('send_manual_order_pos', this.sendManualOrderPos);
    },
    beforeUnmount() {
        EventBus.$off('send_manual_order_pos', this.sendManualOrderPos);
    },
    methods: {
        closeModal() {
            this.$emit('close_modal_send_manual_pos');
        },
        clickYes(){
            const params = {
                orderId: this.activeOrderId,
                actionName: 'sendManualPosOrder'
            }
            this.$store.dispatch('orders/SEND_MANUAL_POS', params);
        },
        clickCancel(){
            this.closeModal();
        },
        sendManualOrderPos() {
            toast.success(__t('O.SEND_MANUAL_POS_ORDER_SUCCESSFULLY'));
            this.closeModal();
        }
    },
    computed: {
        ...mOrders([
            'activeItemMenuOrders',
        ]),
        activeOrderId() {
            if (this.activeItemMenuOrders && this.activeItemMenuOrders.id) {
                return this.activeItemMenuOrders.id;
            }
            return '';
        },
    },
}
</script>
